$(document).ready(function(){
    $('.navigation-mobile-toggle').click(function(){
        $(this).toggleClass('open');
        $('.navigation-mobile').toggle(400);
    });
});
